import { useTranslation } from 'react-i18next';
import { useTheme } from '@mui/material/styles';
import { useDashboard } from '../../../../../contexts';
import type { ChartHeaderData } from '../types';

/**
 * Custom hook for managing Chart Header component state
 * Consolidates all state management and derived values
 */
export const useChartHeaderState = () => {
  // Context data
  const { accountBalance } = useDashboard();

  // Theme and translations
  const { t } = useTranslation('performanceChart');
  const theme = useTheme();

  // Extract and transform data from account balance
  const chartHeaderData: ChartHeaderData = {
    currentPnL: accountBalance?.profitAndLoss || 0,
    equity: accountBalance?.equity || 0,
    closedBalance:
      (accountBalance?.balance || 0) + (accountBalance?.credits || 0),
  };

  return {
    // Data
    chartHeaderData,

    // Theme and translations
    theme,
    t,

    // Raw context data (if needed)
    accountBalance,
  };
};
